var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-edit-topic-form',{attrs:{"is-request-pending":_vm.isUpdateRequestPending,"is-request-failed":_vm.isUpdateRequestFailed,"item":_vm.item},on:{"submit":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }